
import { Component, Prop, Vue } from "vue-property-decorator";
import { Nutritions } from "@/models/Recipes/Nutritions";
import { round } from "@/utils/Helpers";
import vNutritionLabelCanada from "./vNutritionLabelCanada.vue";
import vNutritionLabelUS from "./vNutritionLabelUS.vue";
import vNutritionLabelFSIS from "./vNutritionLabelFSIS.vue";
import vSupplementLabelCanada from "./vSupplementLabelCanada.vue";
import vSupplementLabelUS from "./vSupplementLabelUS.vue";

@Component({
  components: {
    vNutritionLabelCanada,
    vNutritionLabelUS,
    vNutritionLabelFSIS,
    vSupplementLabelCanada,
    vSupplementLabelUS
  },
  methods: {
    utilsRound: round
  }
})
export default class vNutritionLabel extends Vue {
  @Prop() nutrition!: Nutritions;
  @Prop({ default: true }) showRoundedDv!: boolean;
  @Prop() selectedCountry!: string; // Accepts a string like 'Canada', 'US', 'UK'
  @Prop() servingsPerContainer: number;
  @Prop() roundingRule: number;
  @Prop({ default: false }) isSupplementLabel: boolean;

  get selectedNutritionLabelComponent(): string {
    switch (this.selectedCountry) {
    case 'Canada':
    case 'UK':
      return this.isSupplementLabel ? 'vSupplementLabelCanada' : 'vNutritionLabelCanada';
    case 'USA':
      if (this.isSupplementLabel) {
        return 'vSupplementLabelUS';
      }
      return this.roundingRule === 0 ? 'vNutritionLabelUS' : 'vNutritionLabelFSIS';
    default:
      return null;
    }
  }
}
